import React from "react";
import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import IBackupRestoreSetting from "../../models/settings/BackupRestoreSettings";
import {
    Input,
    Button,
    ToggleSwitch,
    ToggleButtonGroup,
    ToggleButton,
    Dropdown,
    DropdownOption,
    Checkbox,
} from "@abb/abb-common-ux-react";
import { Translation } from "react-i18next";
import { ABB_VIEW, ABB_HIDE } from "../../utilities/IconConstants";
import { tree } from "d3-hierarchy";


interface FileExportProps {
    settings: IBackupRestoreSetting;
    setIsNetworkShared: (value: string) => void;
    setDomain: (value: string) => void;
    setUserName: (value: string) => void;
    setPassword: (value: string) => void;
    
    setLocation: (value: string) => void;
    setIpAddress: (value: string) => void;
    setPort: (value: string) => void;
    setAutoGenerate: (value: number) => void;
    testBackupFolderConnection: () => void;

    enableDisableContent: (value: boolean, type: number) => void;
    headingText: string;
    enableDisableContentCount: number;
    ipError: boolean;
    portError: boolean;
    showAutoGenerateToggle: boolean;
}

interface FileExportState {
    isRevelPassword: boolean;
    fileSaveType: {
        label: string,
        value: string
    }[];
}


export default class FileExportSetting extends React.Component<FileExportProps, FileExportState> {
    private _mount: boolean = false;
    private drives: any[] = [
        { value: "Z", label: "Z:" },
        { value: "Y", label: "Y:" },
        { value: "X", label: "X:" },
        { value: "W", label: "W:" },
        { value: "V", label: "V:" },
        { value: "U", label: "U:" },
        { value: "T", label: "T:" },
        { value: "S", label: "S:" },
        { value: "R", label: "R:" },
        { value: "Q", label: "Q:" },
        { value: "P", label: "P:" },
        { value: "O", label: "O:" },
        { value: "N", label: "N:" },
        { value: "M", label: "M:" },
        { value: "L", label: "L:" },
        { value: "K", label: "K:" },
        { value: "J", label: "J:" },
        { value: "I", label: "I:" },
        { value: "H", label: "H:" },
        { value: "G", label: "G:" },
        { value: "F", label: "F:" },
        { value: "E", label: "E:" },
        { value: "D", label: "D:" },
        { value: "B", label: "B:" },
        { value: "A", label: "A:" },
    ];
    private connectionType: any[] = [{
        label: "Local",
        value: "Local"
    },
    {
        label: "Sftp",
        value: "Sftp"
    },
    {
        label: "Network Sharing",
        value: "Network Sharing"
    },
    {
        label: "Ftp",
        value: "Ftp"
    }];
    private autoGenerateType: any[] = [{
        label: "No",
        value: 0
    },
    {
        label: "Yes",
        value: 1
    },
    {
        label: "Autoline",
        value: 2
    }];
    private _fileSaveType: any;
    private _autoGenerateType: any;
    constructor(props: FileExportProps) {
        super(props);
        this._mount = true;
        this.state = {
            isRevelPassword: false,
            fileSaveType: [{
                label: this.connectionType[0].label,
                value: this.connectionType[0].value
            }],
        };
    }

    componentWillUnmount() {
        this._mount = false;
    }

    componentDidMount() {
        this._mount = true;
    }

    private togglePassword = () => {
        this.setState({
            isRevelPassword: !this.state.isRevelPassword,
        });
    };

    private networkChangeHandler = (value: any) => {
        var fileSaveType = [{ label: value[0].label, value: value[0].value }];
        this.setState({ fileSaveType: fileSaveType })
        this.props.setIsNetworkShared(value[0].label);
    }

    public render() {
        const data: any = this.props?.settings
        this._fileSaveType = {
            label: this.props.settings?.fileSaveType,
            value: this.props.settings?.fileSaveType,
        };
        this._autoGenerateType = this.autoGenerateType.filter((x: any) => x.value === this.props.settings?.autoGenerateType)
        let locationPlaceHolder: string
        if (data.fileSaveType === "Local") {
            locationPlaceHolder = CONSTANTS.LOCAL_BACKUP_FOLDER_PLACEHOLDER
        } else if (data.fileSaveType === "Network Sharing") {
            locationPlaceHolder = CONSTANTS.SELECT_XML_PLACEHOLDER
        } else {
            locationPlaceHolder = CONSTANTS.SFTP_FTP_BACKUP_FOLDER_PLACEHOLDER
        }
        return (
            <Translation>
                {(t) => (
                    <div
                        className="export-card-setting"
                    >
                        <div
                            style={{ padding: "5px 20px" }}
                        >
                            <div
                                className="row"
                                style={{ margin: "10px 0 20px 0", borderBottom: "2px solid #bababa", padding: 0 }}
                            >

                                <h6 className="flex-full-width">
                                    <p style={{ width: '80%' }} className="no-margin">
                                        <b>{this.props.headingText}</b>
                                    </p>
                                    <div className="checkbox-right"><Checkbox
                                        label=""
                                        sizeClass="small"
                                        value={this.props.settings && this.props.settings?.isActive ? true : false}
                                        allowIndeterminate={true}
                                        monochrome={true}
                                        style={{ marginTop: '-6px' }}
                                        onChange={(e) => {
                                            this.props.enableDisableContent(e, this.props.enableDisableContentCount)
                                        }}
                                    /></div>
                                </h6>
                            </div>

                            {this.props?.settings &&
                                (
                                    <div key={data.id} className={!data.isActive ? 'blur-disable-background' : ''}>
                                        <div className="d-flex mt-3">
                                            <label
                                                className="width-40"
                                            >
                                                <b>{t("Auto Generate")}</b>
                                            </label>
                                            <div className="width-60">
                                            {this.props.showAutoGenerateToggle ? 
                                                (
                                                    <ToggleSwitch
                                                        monochrome={true}
                                                        showIcons={true}
                                                        className="spinner-position"
                                                        value={data.autoGenerateType === 1 ? true : false}
                                                        onChange={(value) =>
                                                            this.props.setAutoGenerate(value ? 1 : 0)
                                                        }
                                                    />
                                                ) : (
                                                    <Dropdown
                                                        searchable={true}
                                                        value={this._autoGenerateType}
                                                        onChange={(value) => this.props.setAutoGenerate(value[0].value)}
                                                        className="width-100"
                                                    >
                                                        {this.autoGenerateType?.map(
                                                            (o: any, index: any) => (
                                                                <DropdownOption
                                                                    key={index}
                                                                    label={o.label}
                                                                    value={o.value}
                                                                />
                                                            )
                                                        )}
                                                    </Dropdown>
                                                )
                                            }

                                            </div>
                                        </div>

                                        <div className="d-flex mt-3">
                                            <label
                                                className="width-40"
                                            >
                                                {t(
                                                    CONSTANTS.NETWORK + " " + CONSTANTS.CONNECTION_TYPE
                                                )}
                                            </label>
                                            <Dropdown
                                                searchable={true}
                                                value={this._fileSaveType}
                                                onChange={(value) => this.networkChangeHandler(value)}
                                                className="width-60"
                                            >
                                                {this.connectionType?.map(
                                                    (o: any, index: any) => (
                                                        <DropdownOption
                                                            key={index}
                                                            label={o.label}
                                                            value={o.value}
                                                        />
                                                    )
                                                )}
                                            </Dropdown>
                                        </div>

                                        {data.fileSaveType ? (
                                            <div>
                                                {this._fileSaveType.label === "Network Sharing" && (<div className="d-flex mt-3">
                                                    <label className="width-40">
                                                        {t(CONSTANTS.LABEL_DOMAIN)}
                                                    </label>
                                                    <Input
                                                        dataType="text"
                                                        className="width-60"
                                                        value={
                                                            data !== null
                                                                ? data.domain
                                                                : ""
                                                        }
                                                        onValueChange={(value) =>
                                                            this.props.setDomain(value)
                                                        }
                                                    />
                                                </div>)}

                                                {(this._fileSaveType.label === "Sftp" || this._fileSaveType.label === "Ftp") &&
                                                    (<React.Fragment><div className="d-flex mt-3">
                                                        <label className="width-40">
                                                            {t(CONSTANTS.IP_ADDRESS)}
                                                            <span className="required">*</span>
                                                        </label>
                                                        <Input
                                                            dataType="text"
                                                            className={
                                                                this.props.ipError
                                                                    ? "error-code width-60"
                                                                    : "width-60"
                                                            }
                                                            value={
                                                                data !== null
                                                                    ? data.ipAddress
                                                                    : ""
                                                            }
                                                            required={true}
                                                            onValueChange={(value) =>
                                                                this.props.setIpAddress(value)
                                                            }
                                                            placeholder="000.000.000.000"
                                                            maxLength={15}
                                                            showValidationBarWhenInvalid={
                                                                this.props.ipError
                                                            }
                                                            description={
                                                                this.props.ipError &&
                                                                t(CONSTANTS.IP_VALIDATION_ERROR)
                                                            }
                                                        />
                                                    </div>

                                                        <div className="d-flex mt-3">
                                                            <label className="width-40">
                                                                {t(CONSTANTS.PORT)}
                                                                <span className="required">*</span>
                                                            </label>
                                                            <Input
                                                                dataType="text"
                                                                required={true}
                                                                className={
                                                                    this.props.portError ? "error-code width-60" : "width-60"
                                                                }
                                                                value={
                                                                    data !== null
                                                                        ? data.port
                                                                        : ""
                                                                }
                                                                onValueChange={(value) =>
                                                                    this.props.setPort(value)
                                                                }
                                                                maxLength={4}
                                                                showValidationBarWhenInvalid={this.props.portError}
                                                                description={
                                                                    this.props.portError &&
                                                                    t(CONSTANTS.PORT_VALIDATION_ERROR)
                                                                }
                                                            />
                                                        </div></React.Fragment>)}

                                                {this._fileSaveType.label !== "Local" && (<React.Fragment><div className="d-flex mt-3">
                                                    <label className="width-40">
                                                        {t(CONSTANTS.LABLE_INSTRUMENT_USERNAME)}
                                                        <span className="required">*</span>
                                                    </label>
                                                    <Input
                                                        dataType="text"
                                                        className="width-60"
                                                        required={true}
                                                        value={
                                                            data !== null
                                                                ? data.username
                                                                : ""
                                                        }
                                                        onValueChange={(value) =>
                                                            this.props.setUserName(value)
                                                        }
                                                    />
                                                </div>

                                                    <div className="d-flex mt-3">
                                                        <label className="width-40">
                                                            {t(CONSTANTS.LABLE_INSTRUMENT_PASSWORD)}
                                                            <span className="required">*</span>
                                                        </label>
                                                        <Input
                                                            dataType={
                                                                this.state.isRevelPassword
                                                                    ? "text"
                                                                    : "password"
                                                            }
                                                            className="width-60"
                                                            required={true}
                                                            value={
                                                                data !== null
                                                                    ? data.password
                                                                    : ""
                                                            }
                                                            onValueChange={(value) =>
                                                                this.props.setPassword(value)
                                                            }
                                                            icon={
                                                                this.state.isRevelPassword
                                                                    ? ABB_VIEW
                                                                    : ABB_HIDE
                                                            }
                                                            onIconClick={this.togglePassword}
                                                        />
                                                    </div></React.Fragment>)}
                                            </div>
                                        ) : null}

                                        <div className="d-flex mt-3">
                                            <label className="width-40">
                                                {t(CONSTANTS.LABEL_LOCATION)}
                                                {(this._fileSaveType.label === "Network Sharing" ||
                                                    this._fileSaveType.label === "Local") &&
                                                    <span className="required">*</span>}
                                            </label>
                                            <Input
                                                className="width-60"
                                                dataType="text"
                                                placeholder={t(locationPlaceHolder)}
                                                value={data.location}
                                                onValueChange={(value) =>
                                                    this.props.setLocation(value)
                                                }
                                                required={(this._fileSaveType.label === "Network Sharing" ||
                                                    this._fileSaveType.label === "Local") ? true : false}
                                            />
                                        </div>
                                        <div className="row mt-3 test-button">
                                            <Button
                                                type="primary-black"
                                                shape="pill"
                                                className="spinner-position "
                                                text={t(CONSTANTS.BUTTON_TEST)}
                                                style={{ width: "100px" }}
                                                onClick={() =>
                                                    this.props.testBackupFolderConnection()
                                                }
                                                isLoading={
                                                    this.props.settings.isTestLoading
                                                }
                                            />
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                )}
            </Translation>
        );
    }

}